import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Observable, of } from 'rxjs';
import icClose from '@iconify/icons-ic/twotone-close';
import { CrudModeEnum } from '../../../../../../../core/base/enum/crud-mode.enum';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { FormModalBaseComponent } from '../../../../../../../core/base/components/form-modal-base/form-modal-base.component';
import { BuildingService } from '../../../../building/building.service';
import { EquipmentModel } from '../../../../../../../core/models/equipment.model';
import { EquipmentService } from '../../../equipment.service';
import { ErrorApi } from '../../../../../../../core/models/api/error-api';
import { map } from 'rxjs/operators';
import { ResponseTypeEnum } from '../../../../../../../core/base/enum/response-type.enum';

@Component({
  selector: 'vex-equipment-activity-create-update-delete',
  templateUrl: './equipment-activity-create-update-delete.component.html',
  styleUrls: ['./equipment-activity-create-update-delete.component.scss'],
})
export class EquipmentActivityCreateUpdateDeleteComponent
  extends FormModalBaseComponent<EquipmentModel>
  implements OnInit
{
  form: UntypedFormGroup;
  mode: CrudModeEnum;

  icClose = icClose;

  loading = false;
  defaults: any;
  successCreateMessage: string;
  successUpdateMessage: string;
  successDeleteMessage: string;
  errorCreateMessage: string;
  errorUpdateMessage: string;
  errorDeleteMessage: string;

  CrudModeEnum = CrudModeEnum;

  activities$: Observable<any>;
  building: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<FormModalBaseComponent<EquipmentModel>>,
    public service: EquipmentService,
    private buildingService: BuildingService,
  ) {
    super(data, dialogRef, service);
  }

  ngOnInit(): void {
    this.mode = this.data.mode;
    this.defaults = this.data.defaults;
    this.building = this.data.equipment?.location?.building;
    this.activityAutocompleteChange(this.building?._id);

    this.form = new UntypedFormGroup({
      _id: new UntypedFormControl(this.defaults?._id),
      building: new UntypedFormControl(this.building, [Validators.required]),
      activity: new UntypedFormControl(this.defaults?.activity, [Validators.required]),
      percent: new UntypedFormControl(this.defaults?.percent, [Validators.required]),
    });
  }

  activityAutocompleteChange(id: string): void {
    if (!id) {
      this.activities$ = of([]);
      return;
    }

    this.activities$ = this.buildingService.findBuildingById(id).pipe(
      map(response => {
        const building = response.data;
        // Filtrer les activités qui ne sont pas déjà associées à l'équipement
        return building.activities
          .filter(activity => {
            // Vérifier si cette activité n'est pas déjà associée à l'équipement
            return !this.data.equipment?.activities?.some(x => x.activity._id === activity.activity._id);
          })
          .map(activity => activity.activity)
          .filter(activity => activity !== undefined);
      }),
    );
  }

  isCreateMode() {
    return this.mode === CrudModeEnum.Create;
  }

  isUpdateMode() {
    return this.mode === CrudModeEnum.Update;
  }

  isDeleteMode() {
    return this.mode === CrudModeEnum.Delete;
  }

  save() {
    if (this.isCreateMode()) {
      this.createItem();
    } else if (this.isUpdateMode()) {
      this.updateItem();
    }
  }

  createItem() {
    if (this.form.valid) {
      this.service.createActivity(this.data.equipment._id, this.form.getRawValue()).subscribe(
        res => {
          this.afterCreateItem(res, null);
          this.setSnackbar(ResponseTypeEnum.Success, CrudModeEnum.Create, res.message);
          this.close(res.data);
        },
        err => {
          this.setErrorsMessages(err.error.errors);
        },
      );
    } else {
      this.form.markAllAsTouched();
    }
  }

  updateItem() {
    if (this.form.valid) {
      this.service.updateActivity(this.data.equipment._id, this.form.getRawValue()).subscribe(
        res => {
          this.afterCreateItem(res, null);
          this.close(res.data);
        },
        err => {
          this.setErrorsMessages(err.error.errors);
        },
      );
    } else {
      this.form.markAllAsTouched();
    }
  }

  deleteItem() {
    if (this.defaults) {
      this.service.deleteActivity(this.data.equipment._id, this.defaults._id).subscribe(
        res => {
          this.afterCreateItem(res, null);
          this.close(res);
        },
        err => {},
      );
    }
  }

  close(res?) {
    this.dialogRef.close(res);
  }

  setErrorsMessages(errors: Array<ErrorApi>) {
    errors?.forEach(error => {
      let err = this.form.controls[error.property].errors;
      if (err === null) {
        err = { messages: [] };
      }
      err.messages.push(error.message);
      this.form.controls[error.property].setErrors(err);
    });
    this.form.markAllAsTouched();
  }
}
